import React from 'react';
import { Pagination } from '@storebrand-digital/pretzel';
import { useDispatch } from 'react-redux';
import { filterActions } from '../Filter/reducer';
import { useDocumentsWithPagination } from './hooks';

function DocumentPagination() {
  const dispatch = useDispatch();
  const { data } = useDocumentsWithPagination();
  const pagination = data?.pagination ?? {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  };
  const totalPages = Math.max(1, pagination.totalPages);
  return (
    <Pagination
      id="document-pagination"
      pages={totalPages}
      active={pagination.currentPage}
      onChange={(_, newPage) => {
        dispatch(filterActions.changePage(newPage));
      }}
      navAriaLabel="Pagination"
      nextAriaLabel="Next page"
      previousAriaLabel="Previous page"
      pageAriaLabel="Page"
    />
  );
}

export default DocumentPagination;
